import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import stepsActions from 'actions/stepsActions';
import signActions from 'actions/signActions';
import { ProfileStep4 } from 'components/newAccountSteps/profileSteps/profileStep4/profileStep4';
import { actions as formActions } from 'react-redux-form';
import { formatText } from 'core/i18n';
import UtagHelper from 'utilities/utagHelper';
import { PATH_CONTRACT, PATH_CONTRACT_FINISHED } from 'constants/uTagConstants/paths';
import preLoaderActions from 'actions/preLoaderActions';
import Headline from 'components/headline';
import { welcomeCard as WelcomeCard } from 'components/welcomeCard/welcomeCard';
import { GBI, GBI_REJECTED, ROBO, ROBO_REJECTED } from 'constants/userProfile';
import DOCUMENTATION_PRODUCT_NAME, {
    getFinalizedContract,
    recordedFinalizedContract,
    RELIABLE,
} from 'utilities/uTagging';
import cryptoJS from 'crypto-js';
import { SuccessSigningView } from 'routes/formsView/SuccessSigningView';
import { getViewNameByStatus } from 'actions/getViewNameByStatus';
import { LOGALTY_IMPLEMENTATION } from 'constants/steps';
import { SIGNED } from 'constants/statusProcess';
import ModalLoader from 'components/modalLoader/ModalLoader';
import { ORIGIN_BY_CHANNEL } from 'constants/uTagConstants/origin';
import { goToErrorsView, recordAndSavePage } from 'actions/errorViewNavigation';
import {
    ERROR_AL_FIRMAR_CONTRATO_LOGALTY,
    ERROR_AL_OBTENER_IMPLEMENTACION_CONTRATO,
    ERROR_OPEN_SINGNING_CONTRACT_STATE,
} from 'constants/analyticsErrors';
import { getGA4EventKeys } from 'utilities/ga4';

class SigningContractView extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            modalLoaderOpen: false,
        };

        this.onHandleChangeStep = this.onHandleChangeStep.bind(this);
        this.onHandleShowPreloader = this.onHandleShowPreloader.bind(this);
        this.onHandleHidePreloader = this.onHandleHidePreloader.bind(this);
        this.handleOpenStateError = this.handleOpenStateError.bind(this);
    }

    UNSAFE_componentWillMount() {
        const { userProfile, sign } = this.props;

        if (userProfile.contract !== 'completed' || sign.get('status') !== 'completed') {
            this.onHandleShowPreloader();
        } else {
            this.onHandleHidePreloader();
        }
    }

    componentDidMount() {
        const { userProfile, products, immStepsState, signActions, recordAndSavePage } = this.props;
        const JointHolderInfo = UtagHelper.getJointHolderInfoFromUserProfile(userProfile);
        const docNumberEncrypted = userProfile.docNumber ? cryptoJS.SHA256(userProfile.docNumber).toString() : '';

        if (userProfile.eventParam !== 'signing_complete') {
            signActions.getOnboardingImplementation(userProfile.accessToken, () => {
                goToErrorsView({ errorMessage: ERROR_AL_OBTENER_IMPLEMENTACION_CONTRATO });
            });
        }

        if (
            userProfile.contract === 'completed' ||
            (typeof userProfile.eventParam !== 'undefined' &&
                (userProfile.eventParam === 'signing_complete' || userProfile.eventParam === 'viewing_complete'))
        ) {
            if (!getFinalizedContract()) {
                recordedFinalizedContract();
                !immStepsState.get('welcomeCard') &&
                    recordAndSavePage(
                        PATH_CONTRACT_FINISHED,
                        userProfile.recordId,
                        userProfile.userId,
                        userProfile.product,
                        products.get('productsDescription'),
                        userProfile.promoCode ? userProfile.promoCode : '',
                        JointHolderInfo,
                        RELIABLE[userProfile.identityMethod],
                        '',
                        userProfile.investmentType,
                        {
                            ...getGA4EventKeys({
                                eventName: 'step_contract_signed',
                                pageName: '/onboarding/step7a/contractSigned',
                                processDetail: 'contractSigned',
                                onboardingType: userProfile.investmentType,
                            }),
                            nombreProducto: DOCUMENTATION_PRODUCT_NAME,
                            identificadorOnboarding: docNumberEncrypted,
                            processStep: 'step7a',
                            onboardingR: userProfile.clientRisk || '',
                            onboardingIdMethod: RELIABLE[userProfile.identityMethod],
                            onboardingOrigin: ORIGIN_BY_CHANNEL[userProfile.channel],
                        }
                    );
            }
        } else {
            !immStepsState.get('welcomeCard') &&
                recordAndSavePage(
                    PATH_CONTRACT,
                    userProfile.recordId,
                    userProfile.userId,
                    userProfile.product,
                    products.get('productsDescription'),
                    userProfile.promoCode ? userProfile.promoCode : '',
                    JointHolderInfo,
                    RELIABLE[userProfile.identityMethod],
                    '',
                    userProfile.investmentType,
                    {
                        ...getGA4EventKeys({
                            eventName: 'step_contract',
                            pageName: '/onboarding/step7/contract',
                            processDetail: 'contract',
                            onboardingType: userProfile.investmentType,
                        }),
                        identificadorOnboarding: docNumberEncrypted,
                        nombreProducto: DOCUMENTATION_PRODUCT_NAME,
                        processStep: 'step7',
                        onboardingR: userProfile.clientRisk || '',
                        onboardingIdMethod: RELIABLE[userProfile.identityMethod],
                        onboardingOrigin: ORIGIN_BY_CHANNEL[userProfile.channel],
                    }
                );
        }
    }

    componentDidUpdate() {
        const { userProfile, sign } = this.props;

        if (userProfile.contract !== 'completed' || sign.get('status') !== 'completed') {
            this.onHandleHidePreloader();
        }

        return true;
    }

    onHandleShowPreloader() {
        const { userProfile, signActions, preLoaderActions, sign, goToErrorsView } = this.props;

        const isLogalty = sign.get('implementation') === LOGALTY_IMPLEMENTATION;

        const contractToken = sign.get('contractToken');

        if (typeof userProfile.eventParam !== 'undefined' && userProfile.eventParam === 'signing_complete') {
            signActions.getContractStatus(userProfile.accessToken, isLogalty, contractToken);
            let checkStatusInterval;
            let openStateTimeout;
            let errorTimeout;
            const envelopeId = sign.get('envelopeId');

            if (typeof this.checkStatusInterval === 'undefined') {
                checkStatusInterval = setInterval(() => {
                    signActions.getContractStatus(userProfile.accessToken, isLogalty, contractToken);
                }, 3000);
                this.checkStatusInterval = checkStatusInterval;

                if (isLogalty) {
                    openStateTimeout = setTimeout(() => {
                        signActions.getOpenStateStatus(
                            userProfile.accessToken,
                            sign.get('contractToken'),
                            envelopeId,
                            this.handleOpenStateError
                        );
                    }, 30000);
                    this.openStateTimeout = openStateTimeout;

                    errorTimeout = setTimeout(() => {
                        clearInterval(this.checkStatusInterval);
                        goToErrorsView({ errorMessage: ERROR_AL_FIRMAR_CONTRATO_LOGALTY });
                    }, 80000);
                    this.errorTimeout = errorTimeout;
                }
            }
            setTimeout(() => {
                if (isLogalty) {
                    this.setState({ modalLoaderOpen: true });
                } else {
                    preLoaderActions.setInformationText(formatText('informationText-signing'));
                    preLoaderActions.showPreLoader();
                }
            }, 250);
        }
    }

    handleOpenStateError() {
        clearInterval(this.checkStatusInterval);
        goToErrorsView({ errorMessage: ERROR_OPEN_SINGNING_CONTRACT_STATE });
    }

    onHandleHidePreloader() {
        const { userProfile, preLoaderActions, sign } = this.props;
        const isLogalty = sign.get('implementation') === LOGALTY_IMPLEMENTATION;

        if (userProfile.contract === 'completed' || sign.get('status') === 'completed') {
            clearInterval(this.checkStatusInterval);
            if (isLogalty) {
                clearTimeout(this.errorTimeout);
                clearTimeout(this.openStateTimeout);
            }

            setTimeout(() => {
                if (isLogalty) {
                    this.setState({ modalLoaderOpen: false });
                } else {
                    preLoaderActions.hidePreLoader();
                }
            }, 250);
        }
    }

    onHandleChangeStep() {
        const { userProfile, signActions, formActions, actions, immStepsState, preLoaderActions } = this.props;
        const currentStep = immStepsState.get('currentStep');

        preLoaderActions.showPreLoader();
        signActions.confirmContract(userProfile.documentation, userProfile.accessToken, ({ status }) => {
            if (
                userProfile.investmentType === ROBO ||
                userProfile.investmentType === GBI ||
                userProfile.investmentType === ROBO_REJECTED ||
                userProfile.investmentType === GBI_REJECTED
            ) {
                formActions.change('userProfile.status', 'pre-documentation');
            } else {
                formActions.change('userProfile.status', status || 'documentation');
            }
            actions.finalizeStep({ index: currentStep, finished: true });
            actions.enableFinishedAndNextStep();
            actions.changeCurrentStep({
                viewName: getViewNameByStatus(status),
            });
            preLoaderActions.hidePreLoader();
        });
    }

    getSigningView() {
        return <ProfileStep4 />;
    }

    render() {
        const { userProfile, sign } = this.props;
        const isLogalty = sign.get('implementation') === LOGALTY_IMPLEMENTATION;

        const isOnboardingStatusSigned = userProfile.status === SIGNED;
        const isContractCompleted = userProfile.contract === 'completed';
        const isSigningComplete = userProfile.eventParam === 'signing_complete';
        const isViewingComplete = userProfile.eventParam === 'viewing_complete';

        if (
            (isOnboardingStatusSigned || isLogalty) &&
            (isContractCompleted || isSigningComplete || isViewingComplete)
        ) {
            return (
                <div className="basic-layering">
                    <ModalLoader open={this.state.modalLoaderOpen} onClose={null} />
                    <SuccessSigningView
                        investmentType={userProfile.investmentType}
                        onHandleChangeStep={this.onHandleChangeStep}
                    />
                    <WelcomeCard />
                </div>
            );
        }

        return (
            <div className="basic-layering">
                <div className="signing__header">
                    <Headline icon="firma" className="prospects-gutter">
                        <h2>{formatText('contentStepsTitles-signContract')}</h2>
                        <p>{formatText('contentStepsTitles-yourSignature')}</p>
                    </Headline>
                </div>
                {this.getSigningView()}
                <WelcomeCard />
            </div>
        );
    }
}

module.exports.constructor = SigningContractView;
module.exports.SigningContractView = connect(
    state => ({
        userProfile: state.userProfile,
        immStepsState: state.steps,
        sign: state.sign,
        products: state.products,
    }),
    dispatch => ({
        formActions: bindActionCreators(formActions, dispatch),
        actions: bindActionCreators(stepsActions, dispatch),
        signActions: bindActionCreators(signActions, dispatch),
        preLoaderActions: bindActionCreators(preLoaderActions, dispatch),
        goToErrorsView: bindActionCreators(goToErrorsView, dispatch),
        recordAndSavePage: bindActionCreators(recordAndSavePage, dispatch),
    })
)(SigningContractView);
